import React, { useState, useRef } from 'react';
import { MicIcon, SendIcon } from 'lucide-react';
interface ChatInputProps {
  onSend: (message: string) => void;
  onStartRecording: () => void;
  onStopRecording: () => void;
  isListening: boolean;
  suggestions?: string[];
}
const ChatInput = ({
  onSend,
  onStartRecording,
  onStopRecording,
  isListening,
  suggestions = []
}: ChatInputProps) => {
  const [inputText, setInputText] = useState('');
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const handleSend = () => {
    if (inputText.trim()) {
      onSend(inputText.trim());
      setInputText('');
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };
  // Show suggestions only when input is empty
  const showSuggestions = !inputText.trim();
  return <div data-id="element-40">
      {/* Compact suggestions */}
      {showSuggestions && suggestions.length > 0 && <div className="flex gap-2 mb-3 -mt-1" data-id="element-41">
          {suggestions.slice(0, 2).map((suggestion, index) => <button key={index} onClick={() => {
        setInputText(suggestion);
        inputRef.current?.focus();
      }} className="px-3 py-1.5 bg-lavender/10 dark:bg-lavender/20 
                text-lavender rounded-lg text-sm transition-all 
                hover:bg-lavender/20 active:scale-[0.98]" data-id="element-42">
              {suggestion}
            </button>)}
        </div>}
      {/* Input Area */}
      <div className="flex items-center gap-2 bg-white dark:bg-slate-800 rounded-xl p-2" data-id="element-43">
        <button onClick={() => isListening ? onStopRecording() : onStartRecording()} className={`
            p-2 rounded-lg transition-all flex-shrink-0
            ${isListening ? 'bg-soft-coral text-white animate-pulse' : 'bg-gray-100 dark:bg-slate-700 text-gray-600 dark:text-gray-300'}
          `} aria-label={isListening ? 'Stop speaking' : 'Start speaking'} data-id="element-44">
          <MicIcon className="w-5 h-5" data-id="element-45" />
        </button>
        <input ref={inputRef} value={inputText} onChange={e => setInputText(e.target.value)} onKeyDown={handleKeyDown} className="flex-1 px-3 py-2 text-base bg-transparent dark:text-white 
            focus:outline-none rounded-lg" placeholder="Type a message or tap the mic..." data-id="element-46" />
        <button onClick={handleSend} disabled={!inputText.trim()} className={`
            p-2 rounded-lg transition-all flex-shrink-0
            ${inputText.trim() ? 'bg-lavender text-white' : 'bg-gray-100 dark:bg-slate-700 text-gray-400'}
          `} aria-label="Send message" data-id="element-47">
          <SendIcon className="w-5 h-5" data-id="element-48" />
        </button>
      </div>
    </div>;
};
export default ChatInput;